import {IconName} from '@cov/ui-angular';
import {Permission} from '../../../enums/permissions.enum';
import {DEALS, FINANCE, ORDERS, SUPPORT_HUB} from '../../constants';
import type {NavigationItem} from './types/navigation.types';

// permissions array can contain a list of strings and will be checked against the hasAnyPermission method from UserService

// The Negotiations entry is shown only when the negotiation feature flag is on, the user
// holds the same permission as the Prices tab, and the caller is a negotiator
// (requiresNegotiator, derived from GET /api/user/c4c-contacts?scope=self, fail-closed).
export function buildNavigation(isNegotiationEnabled: boolean): NavigationItem[] {
  return [
    {
      label: 'navbar.home',
      route: '/',
      permissions: [], // list of strings will be checked against the hasAnyPermission method from user.service
      children: [],
      icon: IconName.HOME,
    },
    {
      label: 'navbar.pricesPrices',
      route: DEALS,
      permissions: [Permission.COVESTRO_VIEW_PRICE_LIST],
      children: [
        {
          label: 'navbar.pricesPriceList',
          route: `${DEALS}/prices`,
          permissions: [Permission.COVESTRO_VIEW_PRICE_LIST],
          children: [],
          isExternal: true,
        },
        ...(isNegotiationEnabled
          ? [
              {
                label: 'navbar.negotiations',
                route: `${DEALS}/negotiations`,
                permissions: [Permission.COVESTRO_VIEW_PRICE_LIST],
                children: [],
                isExternal: true,
                requiresNegotiator: true,
              },
            ]
          : []),
      ],
      icon: IconName.MONEY,
      isExternal: true,
    },
    {
      label: 'navbar.ordersOverview',
      route: ORDERS,
      permissions: [],
      children: [
        {
          label: 'navbar.ordersOpen',
          route: `${ORDERS}/open`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersChangeable',
          route: `${ORDERS}/changeable`,
          permissions: [Permission.COVESTRO_CHANGE_ORDER],
          children: [],
        },
        {
          label: 'navbar.ordersSelfPickup',
          route: `${ORDERS}/self-pickup`,
          permissions: [Permission.COVESTRO_SELF_PICKUP],
          children: [],
        },
        {
          label: 'navbar.ordersShipped',
          route: `${ORDERS}/shipped`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersVolumesPurchased',
          route: `${ORDERS}/volumes-purchased`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersSample',
          route: `${ORDERS}/sample`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersAll',
          route: `${ORDERS}/all`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersUpcoming',
          route: `${ORDERS}/upcoming`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.ordersRailcarTracking',
          route: `${ORDERS}/railcar-tracking`,
          permissions: [Permission.COVESTRO_RAILCAR_TRACKING],
          children: [],
        },
        {
          label: 'navbar.ordersAllForWeChat',
          route: `${ORDERS}/all-wechat`,
          permissions: [Permission.COVESTRO_CHINA],
          children: [],
        },
        {
          label: 'navbar.ordersHistoric',
          route: `${ORDERS}/historic`,
          permissions: [Permission.COVESTRO_CREATE_STANDARD_ORDER],
          children: [],
        },
        {
          label: 'navbar.ordersOrderTemplates',
          route: `${ORDERS}/templates`,
          permissions: [Permission.COVESTRO_CREATE_STANDARD_ORDER],
          children: [],
        },
      ],
      icon: IconName.COPY,
    },
    {
      label: 'navbar.financeOverview',
      route: FINANCE,
      permissions: [Permission.COVESTRO_ACCOUNT_RECEIVABLE],
      children: [
        {
          label: 'navbar.financeAllInvoices',
          route: `${FINANCE}/all`,
          permissions: [],
          children: [],
        },
        {
          label: 'navbar.financeOpenInvoices',
          route: `${FINANCE}/open`,
          permissions: [],
          children: [],
        },
      ],
      icon: IconName.FINANCES,
    },
    {
      label: 'navbar.supportHubOverview',
      route: SUPPORT_HUB,
      permissions: [],
      children: [
        {
          label: 'navbar.supportHubInquiries',
          route: `${SUPPORT_HUB}/inquiries`,
          permissions: [],
          children: [],
        },
        /*{
        label: 'navbar.supportHubComplaints',
        route: `${SUPPORT_HUB}/complaints`,
        permissions: [],
        children: [],
      },*/
      ],
      icon: IconName.MAIL,
    },
  ];
}

export const navigation: NavigationItem[] = buildNavigation(
  String(import.meta.env.NG_APP_CX_FEATURE_NEGOTIATION).toLowerCase() === 'true',
);
